// extracted by mini-css-extract-plugin
module.exports = {"page":"page_page__giuJC","section":"page_section__zT7yU","article":"page_article__x_MOW","aside":"page_aside__XWm96","main":"page_main__vKQsR","bottom":"page_bottom__kCLva"};